import { call } from "../helpers/axiosInterceptor";

const getBatches = async () => {
  try {
    const { data } = await call.get("batch", {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("refToken"),
      },
    });

    return data;
  } catch (e) {
    
  }
};


const createBatche = async (payload: any) => {
  try {
    const { data } = await call.post("batch", payload,
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("refToken"),
        }
      },);
    return data;
  } catch (e) {

  }
};

const getNewBatcheID = async (course) => {
  try {
    
    const { data } = await call.get(`batch/get/id/${course}`,
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("refToken"),
        }
      },);
    return data;
  } catch (e) {

  }
};


const getAdminbatches = async (id) => {
  const { data } = await call.get(`batch/search/admin-batch/${id}`,
    {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("refToken"),
      }
    },);
  return data;
};

const updateBatch = async (payload: any) => {
  try {

    const { data } = await call.post("batch/update", payload,
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("refToken"),
        }
      },);
    return data;
  } catch (e) {

  }
};

const getBatchesBysearch = async (query) => {
  try {
    const { data } = await call.get(`batch/search/${query}`,
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("refToken"),
        }
      },);
    return data;
  } catch (e) {

  }
};

const deleteBatch = async (batchId: string) => {
  try {
    

    const response = await call.delete(`/batch/delete/${batchId}`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("refToken"),
      },
    });
    
  } catch (e: any) {
    console.error("Error deleting batch:", e.response?.data?.message || e.message);
  }
};

const addStudentsToBatch = async (studentNames: string[]) => {
  try {
    const response = await call.post(
      "/batch/add-students",
      { students: studentNames }, // ✅ Data object
      { headers: { "Content-Type": "application/json" } } // ✅ 3rd argument added
    );

    return response.data;
  } catch (error) {
    console.error("Error sending students to backend:", error);
    throw error;
  }
};

export {
  getBatches,
  getNewBatcheID,
  createBatche,
  updateBatch,
  getBatchesBysearch,
  getAdminbatches,
  deleteBatch,
  addStudentsToBatch,
};